import { Badge } from "@/components/ui/badge";

export const PAYMENT_LABEL = {
  efectivo: { label: "Efectivo", className: "bg-[#D1E0D7] text-[#1F2A24]" },
  tarjeta: { label: "Tarjeta", className: "bg-[#D7E0EA] text-[#1F2A24]" },
  transferencia: { label: "Transferencia", className: "bg-[#E0D7E0] text-[#1F2A24]" },
  bizum: { label: "Bizum", className: "bg-[#E0D7C8] text-[#1F2A24]" },
  financiacion: { label: "Financiación", className: "bg-[#F3E5D8] text-[#7C5A2A]" },
  otro: { label: "Otro", className: "bg-[#EAE6DF] text-[#1F2A24]" },
};

export const FREQ_LABEL = {
  semanal: "semanal",
  quincenal: "quincenal",
  mensual: "mensual",
  bimestral: "bimestral",
  trimestral: "trimestral",
};

export const PaymentBadge = ({ inv }) => {
  const pm = inv?.payment_method;
  if (!pm) return <span className="text-xs text-[#9CA3AF]">—</span>;
  const conf = PAYMENT_LABEL[pm] || { label: pm, className: "bg-[#EAE6DF]" };
  const freq = FREQ_LABEL[inv.financing_frequency] || "";
  const cuota = inv.financing_monthly_amount ? Number(inv.financing_monthly_amount) : 0;
  return (
    <div className="flex items-center gap-1 flex-wrap">
      <Badge className={conf.className}>{pm === "financiacion" ? "A plazos" : conf.label}</Badge>
      {pm === "financiacion" && inv.financing_provider === "centro" && (
        <Badge
          className="bg-[#C9B79C] text-[#3F2E14]"
          title={`A plazos interno — lo cobra el centro${inv.financing_payment_method ? ` en ${inv.financing_payment_method}` : ""}`}
        >
          Interno{inv.financing_payment_method ? ` · ${PAYMENT_LABEL[inv.financing_payment_method]?.label || inv.financing_payment_method}` : ""}
        </Badge>
      )}
      {pm === "financiacion" && inv.financing_provider === "banco" && (
        <Badge className="bg-[#D7E0EA] text-[#1F2A24]" title="A plazos por financiación (financiera / banco)">
          Financiera
        </Badge>
      )}
      {pm === "financiacion" && cuota > 0 && (
        <Badge className="bg-[#F7F6F3] text-[#3F4744] border border-[#E5E3DB]" title="Importe y periodicidad de la cuota">
          {cuota.toFixed(2)} €{freq ? ` · ${freq}` : ""}
        </Badge>
      )}
    </div>
  );
};
